import React, { useEffect } from "react";
import styles from "./Footer.module.scss";
import image1 from "../../../Assets/images/icon/image33.png";
import image2 from "../../../Assets/images/icon/image34.png";
import image3 from "../../../Assets/images/icon/image35.png";
import image4 from "../../../Assets/images/icon/image12.png";
import image5 from "../../../Assets/images/logo2.png";

export function Footer() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www-cdn.icef.com/scripts/iasbadgeid.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.getElementById("iasBadge")?.appendChild(script);
    return () => {
      document.getElementById("iasBadge")?.removeChild(script);
    };
  }, []);

  return (
    <footer className={`text-center ${styles.backgroundColor}`}>
      <div className={`${styles.containerImages}`}>
        <div className={styles.containerLogo}>
          <span>Powered by</span>
          <img
            className={`app-badge ${styles.imageLogo}`}
            src={image5}
            alt="..."
          />
        </div>
        <div className={`text-white-50 small ${styles.containerIcons}`}>
          <div>
            {/* <img
              className={`app-badge ${styles.imageIcons}`}
              src={image1}
              alt="..."
            /> */}
            <img
              className={`app-badge ${styles.imageIcons}`}
              src={image2}
              alt="..."
              onClick={() => {
                window.open("https://www.linkedin.com/company/next-intake-education/posts/?feedView=all");                
              }}
              style={{
                cursor: "pointer",
                filter: "grayscale(100%)"
              }}
            />
            <img
              className={`app-badge ${styles.imageIcons}`}
              src={image3}
              alt="..."
              onClick={() => {
                window.open("https://www.instagram.com/nextintake/")
              }}
              style={{
                cursor: "pointer",
                filter: "grayscale(100%)"
              }}
            />
            <img
              className={`app-badge ${styles.imageIcons}`}
              src={image4}
              alt="..."
              onClick={() => {
                window.open("https://www.facebook.com/nextintake/");                
              }}
              style={{
                cursor: "pointer",
                filter: "grayscale(100%)"
              }}
            />
          </div>
          <div>
            <div className={styles.text1}>©2025 Canadá Sem Fronteiras</div>
            <div className={styles.text2}>©2025 Next Intake</div>
          </div>
        </div>
        <div className={styles.spaceRight}>
          <span
            id="iasBadge"
            data-account-id="6395"
            style={{ height: 140 }}
          ></span>
        </div>
      </div>
    </footer>
  );
}
